import React, { useEffect, useState } from 'react';
import { getEnabledElement } from '@cornerstonejs/core';
import { ToolGroupManager } from '@cornerstonejs/tools';
import PropTypes from 'prop-types';
import { getEnabledElement as OHIFgetEnabledElement } from '../state';
import { UpdateViewportPreview, DownloadBlobSec, ToggleAnnotations, LoadImage } from '../utils/downloadBlobImage';
import { ViewportImagemSecundariaForm } from '../../../../platform/ui/src';

const MINIMUM_SIZE = 100;
const DEFAULT_SIZE = 512;
const MAX_TEXTURE_SIZE = 10000;
const VIEWPORT_ID = 'viewport-1';

const ImagemSecundariaForm = ({
  onClose,
  activeViewportIndex,
  cornerstoneViewportService,
}) => {
  const enabledElement = OHIFgetEnabledElement(activeViewportIndex);
  const activeViewportElement = enabledElement?.element;
  const activeViewportEnabledElement = getEnabledElement(activeViewportElement);
  const [msgFalha, setMsgFalha] = useState("");

  const {
    viewportId: activeViewportId,
    renderingEngineId,
  } = activeViewportEnabledElement;

  const toolGroup = ToolGroupManager.getToolGroupForViewport(
    activeViewportId,
    renderingEngineId
  );

  const toolModeAndBindings = Object.keys(toolGroup.toolOptions).reduce(
    (acc, toolName) => {
      const tool = toolGroup.toolOptions[toolName];
      const { mode, bindings } = tool;

      return {
        ...acc,
        [toolName]: {
          mode,
          bindings,
        },
      };
    },
    {}
  );

  useEffect(() => {
    return () => {
      Object.keys(toolModeAndBindings).forEach(toolName => {
        const { mode, bindings } = toolModeAndBindings[toolName];
        toolGroup.setToolMode(toolName, mode, { bindings });
      });
    };
  }, []);

  const enableViewport = viewportElement => {
    if (viewportElement) {
      return activeViewportElement;
      //downloadBlob
    }
  };

  const disableViewport = viewportElement => {
    if (viewportElement) {
      const { renderingEngine } = getEnabledElement(viewportElement);
      return new Promise(resolve => {
        renderingEngine.disableElement(VIEWPORT_ID);
      });
    }
  };

  const updateViewportPreview = (downloadViewportElement, internalCanvas, fileType) => {
    UpdateViewportPreview(downloadViewportElement,
      internalCanvas,
      fileType,
      DEFAULT_SIZE);
  };

  const loadImage = (activeViewportElement, viewportElement, width, height) => {
    return LoadImage(activeViewportElement, viewportElement, width, height, cornerstoneViewportService, VIEWPORT_ID, MAX_TEXTURE_SIZE);
  }

  const toggleAnnotations = (toggle, viewportElement, activeViewportElement) => {
    ToggleAnnotations(toggle, viewportElement, activeViewportElement);
  }

  const downloadBlob = (filename, fileType) => {
    DownloadBlobSec(filename, fileType, VIEWPORT_ID);
  };

  return (
    <ViewportImagemSecundariaForm
      onClose={onClose}
      minimumSize={MINIMUM_SIZE}
      maximumSize={MAX_TEXTURE_SIZE}
      defaultSize={DEFAULT_SIZE}
      canvasClass={'cornerstone-canvas'}
      activeViewportElement={activeViewportElement}
      enableViewport={enableViewport}
      disableViewport={disableViewport}
      updateViewportPreview={updateViewportPreview}
      loadImage={loadImage}
      toggleAnnotations={toggleAnnotations}
      downloadBlob={downloadBlob}
      activeViewportEnabledElement={activeViewportEnabledElement}
      msgFalha={msgFalha}
    />
  );
};

ImagemSecundariaForm.propTypes = {
  onClose: PropTypes.func,
  activeViewportIndex: PropTypes.number.isRequired,
};

export default ImagemSecundariaForm;
